import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/components/landing/LandingPage";
import ogImage from "@/assets/og-mao-de-obra-temporaria-para-construcao-civil-selectus-rh.jpg.asset.json";
import { getClusterPagesForSegmento } from "@/lib/landing-pages.functions";

const OG_IMAGE_URL = `https://lp.selectusrh.com${ogImage.url}`;

export const Route = createFileRoute("/")({
  loader: async () => {
    const cluster = await getClusterPagesForSegmento({
      data: { segmento: "Construção Civil", currentCidade: "São Paulo" },
    });
    return { cluster };
  },
  component: Index,
  head: () => ({
    meta: [
      { property: "og:image", content: OG_IMAGE_URL },
      { property: "og:image:secure_url", content: OG_IMAGE_URL },
      { property: "og:image:type", content: "image/jpeg" },
      { property: "og:image:width", content: "800" },
      { property: "og:image:height", content: "800" },
      { property: "og:image:alt", content: "Selectus RH - Mão de obra temporária para construção civil" },
      { name: "twitter:image", content: OG_IMAGE_URL },
      { name: "twitter:image:alt", content: "Selectus RH - Mão de obra temporária para construção civil" },
    ],
    links: [{ rel: "canonical", href: "https://lp.selectusrh.com/" }],
  }),
});

function Index() {
  const { cluster } = Route.useLoaderData();
  return <LandingPage clusterPages={cluster} />;
}
